[
  {
    "code": "KI-G",
    "name": "Gilbert Islands"
  },
  {
    "code": "KI-L",
    "name": "Line Islands"
  },
  {
    "code": "KI-P",
    "name": "Phoenix Islands"
  }
]